import React from 'react'

import Modal from '../../Components/Page/Elements/Modal/Modal'
import { LoginContext } from './LoginContext'

const Login = () => {
  // Pegando o contexto do LoginContext
  const { input, setInput, handleLogin, modal, setModal } = React.useContext(LoginContext)
  // Formulario de Login
  return (
    <div className="content w-full h-screen flex justify-center items-center flex-col">
      <h1 className="text-white text-lg py-2">Unbottle Admin</h1>
      <form className="bg-dark-2 px-8 py-4 flex justify-center items-center flex-col border-b border-gray-200 sm:rounded-lg">
        <h2 className="text-base pb-2 w-full">Login</h2>
        <input placeholder="Jigger" value={input.user} onChange={(e) => { setInput({ ...input, user: e.target.value }) }} className="m-2 w-full bg-page text-white rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 p-2" />
        <input placeholder="123" value={input.password} onChange={(e) => { setInput({ ...input, password: e.target.value }) }} className="m-2 w-full bg-page text-white rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 p-2" />
        <div className="w-full text-right">
          <button className="bg-dark-1 hover:bg-dark-2 text-white font-semibold hover:text-white mt-4 p-2 border border-blue-500 hover:border-transparent rounded mr-2" onClick={(e) => { handleLogin(e) }}>Login</button>
        </div>
      </form>
      {/* Modal que se aplica ao clicar em Login. */}
      {(modal.ativo) ? (<Modal setContent={setModal} content={modal} />) : (null)}
    </div>
  )
}

export default Login
